import { render, staticRenderFns } from "./CdrUpload.vue?vue&type=template&id=fec6fafa&"
import script from "./CdrUpload.vue?vue&type=script&lang=ts&"
export * from "./CdrUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports